/** Known raw filter values → display labels (Title Case / proper names) */
const VALUE_LABEL_OVERRIDES = {
  fieldstaff: "Field Staff",
  outsourcedstaff: "Outsourced Staff",
  candidate: "Candidate",
  pickup: "Pickup",
  mail: "Mail",
  active: "Active",
  yes: "Yes",
  no: "No",
  all: "All",
  asc: "Ascending",
  desc: "Descending",
  first_name: "First Name",
  last_name: "Last Name",
  created: "Created",
  type: "Type",
  "pending activation": "Pending Activation",
};

function capitalizeWord(word) {
  if (!word) return "";
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

/**
 * Format a filter value for display: Title Case Each Word.
 * Preserves explicit multi-word labels; maps known internal codes via overrides.
 */
export function capitalizeFilterLabel(value) {
  if (value == null || value === "") return "";
  const raw = String(value).trim();
  const key = raw.toLowerCase();

  if (VALUE_LABEL_OVERRIDES[key]) {
    return VALUE_LABEL_OVERRIDES[key];
  }

  if (/[\s_-]+/.test(raw)) {
    return raw
      .split(/[\s_-]+/)
      .filter(Boolean)
      .map(capitalizeWord)
      .join(" ");
  }

  if (raw === key) {
    return capitalizeWord(key);
  }

  return raw;
}

export default capitalizeFilterLabel;
